import { Typography } from '@execonline-inc/execonline-ui';
import { trackEvent } from '@intercom/messenger-js-sdk';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import notFoundIllustration from '../../../../assets/error-page/404-illustration.svg';
import { T } from '../../../../Translations';

const IMPRESSION_EVENT = 'Discovery Portal - No Active License - Impression';

function EmptyLicenseState() {
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.Intercom) {
        trackEvent(IMPRESSION_EVENT);
      }
    } catch (error) {
      console.warn('Failed to track Intercom event:', IMPRESSION_EVENT, error);
    }
  }, []);

  return (
    <div
      className="flex flex-grow flex-col items-center justify-center px-4 py-16"
      data-intercom-target="discovery-portal-no-license-container"
    >
      <img
        src={notFoundIllustration}
        alt=""
        role="presentation"
        className="mb-6 h-auto w-[240px] sm:w-[300px] md:w-[360px]"
        data-intercom-target="discovery-portal-no-license-illustration"
      />
      <Typography
        className="mb-3 text-center text-black md:mb-4"
        variant="h4"
        as="h1"
        tabIndex={0}
        data-intercom-target="discovery-portal-no-license-title"
      >
        <T kind="discovery_portal.no_active_license.title" />
      </Typography>
      <Typography
        className="max-w-[90%] px-4 text-center text-black md:w-[500px]"
        variant="bodyMedium"
        as="p"
        data-intercom-target="discovery-portal-no-license-message"
      >
        <T kind="discovery_portal.no_active_license.message" />
      </Typography>
    </div>
  );
}

export default observer(EmptyLicenseState);
